var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './SelectionControl.module.scss';
var SelectionControl = memo(function (_a) {
    var _b;
    var checked = _a.checked, children = _a.children, disabled = _a.disabled, name = _a.name, onChange = _a.onChange, onKeyDown = _a.onKeyDown, type = _a.type, value = _a.value, innerRef = _a.innerRef, boxed = _a.boxed, inline = _a.inline, fontWeight = _a.fontWeight, tabIndex = _a.tabIndex, noMargin = _a.noMargin;
    var id = "".concat(name.replace(' ', '-'), "_").concat(value.replace(' ', '-'));
    return (React.createElement("div", { className: classNames(styles.field, (_b = {},
            _b[styles.inline] = inline,
            _b)) },
        React.createElement("input", { checked: checked, className: boxed ? styles.boxedInput : styles.input, disabled: disabled, id: id, name: name, onChange: function () { return onChange(value, !checked); }, onKeyDown: onKeyDown, ref: innerRef, type: type, value: value, tabIndex: tabIndex }),
        React.createElement("label", { htmlFor: id, style: { fontWeight: fontWeight, margin: noMargin ? 0 : undefined } }, children)));
});
SelectionControl.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    boxed: PropTypes.bool,
    checked: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.number, PropTypes.string])),
        PropTypes.element,
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    disabled: PropTypes.bool,
    fontWeight: PropTypes.oneOf(['bold', 'lighter', 'normal']),
    inline: PropTypes.bool,
    innerRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.any,
        }),
    ]),
    name: PropTypes.string.isRequired,
    noMargin: PropTypes.bool,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    tabIndex: PropTypes.number,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    value: PropTypes.string.isRequired,
};
SelectionControl.displayName = 'SelectionControl';
SelectionControl.defaultProps = {
    innerRef: undefined,
    checked: undefined,
    tabIndex: undefined,
    disabled: false,
    onChange: undefined,
    onKeyDown: undefined,
    boxed: false,
    inline: false,
    fontWeight: 'bold',
    noMargin: false,
};
var SelectionControlForwardRef = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(SelectionControl, __assign({}, props, { innerRef: ref }), children));
});
SelectionControlForwardRef.propTypes = {
    boxed: PropTypes.bool,
    checked: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.number, PropTypes.string])),
        PropTypes.element,
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    disabled: PropTypes.bool,
    fontWeight: PropTypes.oneOf(['bold', 'lighter', 'normal']),
    inline: PropTypes.bool,
    innerRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.any,
        }),
    ]),
    name: PropTypes.string.isRequired,
    noMargin: PropTypes.bool,
    onChange: PropTypes.func,
    tabIndex: PropTypes.number,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    value: PropTypes.string.isRequired,
};
SelectionControlForwardRef.defaultProps = {
    innerRef: undefined,
    checked: undefined,
    tabIndex: undefined,
    disabled: false,
    onChange: function () { },
    boxed: false,
    inline: false,
    fontWeight: 'bold',
    noMargin: false,
};
/**
 * @tdr
 * @deprecated since version 11.3.0. `SelectionControl` should not be used any
 * longer. New version of it exists in `src/core/SelectionControl` but it
 * shouldn't be used as a standalone component. It's only meant to be the base
 * component for `Checkbox` and `Radio`.
 * @tdr-deprecated-date: 2022-05-22
 */
export default SelectionControlForwardRef;
//# sourceMappingURL=index.js.map